<script lang="ts">
	import Chip, { Text } from '@smui/chips/styled';
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();

	export let keyword: string;

	const dispatchPlus = () => {
		dispatch('plus');
	};

	const dispatchMinus = () => {
		dispatch('minus');
	};
</script>

<div class="wrapper">
	<span class="text">{keyword}</span>
	<Chip chip="recommendedChip" class="recommended-chip" on:click={dispatchPlus}>
		<Text>+</Text>
	</Chip>
	<Chip chip="recommendedChip" class="recommended-chip" on:click={dispatchMinus}>
		<Text>-</Text>
	</Chip>
</div>

<style lang="scss">
	.wrapper {
		display: flex;
		align-items: center;
		margin-right: 15px;
		margin-bottom: 10px;

		.text {
			margin-right: 5px;
		}

		:global(.recommended-chip) {
			margin-left: 2px;
			margin-right: 2px;
		}
	}
</style>
